export default "__VITE_ASSET__CxABf$c6__"